<template>
    <div class="chat-button-wrapper">
        <div v-if="hasUnreads" class="unread-indicator"></div>
        <div
            id="see-all"
            class="chat-button button-clickable"
            :style="{ bottom: getBottomOffset() + 'px' }"
        >
            <div class="see-more">
                All
            </div>
        </div>
        <b-tooltip
            target="see-all"
            placement="left"
            custom-class="tooltip-wrapper"
            triggers="hover"
            :show.sync="showTooltip"
        >
            <div class="list-wrapper">
                <div v-for="(conv, i) in conversations" :key="i" class="list-item">
                    <div v-if="unreads.includes(conv.id)" class="unread-indicator-inner"></div>
                    <div class="btn px-4" @click="() => conversationClick(conv.id)">
                        {{ conv.participants[0].displayName }}
                    </div>
                    <div class="btn close-btn" @click="() => conversationCloseClick(conv.id)">
                        <BaseIcon size="1x" name="times" />
                    </div>
                </div>
            </div>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: 'SeeAllButton',
    props: {
        count: Number,
        conversations: Array,
        hasUnreads: Boolean,
        unreads: Array,
    },
    data() {
        return {
            spacing: 5,
            itemHeight: 60,
            baseOffset: 80 + 85,
            stackHeight: 10,
            showTooltip: false,
        };
    },
    methods: {
        getBottomOffset() {
            return (this.itemHeight + this.spacing) * 3 + this.baseOffset + this.spacing;
        },
        conversationClick(id) {
            this.$interfaces.communication.chat.conversation.id(id).put({
                body: {
                    open: true,
                },
            });
            this.showTooltip = false;
            this.$emit('conversation-click', id);
        },
        conversationCloseClick(id) {
            this.$emit('conversation-remove', id);
        },
    },
};
</script>

<style scoped>
.chat-button-wrapper {
    display: flex;
    justify-content: center;
    height: 60px;
    width: 60px;
    position: fixed;
    right: 20px;
    bottom: 365px;
}
.chat-button {
    font-size: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    box-shadow: var(--shadow);
    position: fixed;
    right: 20px;

    background: linear-gradient(135deg, rgb(63, 81, 181) 0%, rgb(37, 47, 105) 100%);
    /*background-color: var(--primary);*/
    cursor: pointer;
}
.button-clickable {
    cursor: pointer;
}
.button-clickable:hover {
    opacity: 0.9;
    transition: opacity 0.1s;
}
.see-more {
    color: white;
    text-align: center;
    font-size: 14px;
}
.list-wrapper {
    max-height: 60vh;
    overflow-y: auto;
}
.list-item {
    padding: 3px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 4;
    position: relative;
}
.list-item .btn {
    cursor: pointer;
    color: white;
    text-align: left;
}
.list-item .btn:hover {
    background-color: rgb(40, 40, 60);
}
.close-btn {
    border-radius: 50%;
    padding: 5px;
}
.unread-indicator {
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid black;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    align-items: center;
    text-align: center;
    font-size: 13px;
    background-color: red;
    cursor: pointer;
    z-index: 1;
}
.unread-indicator-inner {
    border: 1px solid black;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    align-items: center;
    text-align: center;
    font-size: 13px;
    background-color: red;
    cursor: pointer;
    z-index: 1;
    position: absolute;
}
</style>
<style>
.tooltip-wrapper .tooltip-inner {
    max-width: 300px !important;
}
</style>
